import React from 'react';

export const DropdownSelectSeparator = () => <li className="dropdown-select__separator"/>;
